import {ChooseNoAvailable} from "../../action/generalActions/choosenotavailable.action";

export type ErrorStateActions = ChooseNoAvailable;

export const errorStateActions = [ChooseNoAvailable] as const;

export type errActions = (typeof errorStateActions)[number];
